// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1lSy3","header":"ReportDetails_header__2jGkL","title":"ReportDetails_title__2p_HD","left":"ReportDetails_left__2qYDi"};